import { render } from "./RouteSettings.vue?vue&type=template&id=3ad2d02b&scoped=true"
import script from "./RouteSettings.vue?vue&type=script&lang=ts"
export * from "./RouteSettings.vue?vue&type=script&lang=ts"

import "./RouteSettings.vue?vue&type=style&index=0&id=3ad2d02b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ad2d02b"

export default script